var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{staticClass:"number-control",attrs:{"label":_vm.$t(_vm.label)}},[_c('b-form-input',{attrs:{"type":"number","step":_vm.options.step,"min":_vm.options.min,"max":_vm.options.max,"value":_vm.value},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }